<template>
  <div class="hold-transition">
    <div class="modal fade" id="modal_form_ruta_export">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar Listado Rutas</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-6">
                <div class="card card-light m-0">
                  <div class="card-header">
                    <h4 class="card-title">Filtros</h4>
                  </div>
                  <div class="card-body pb-0">
                    <div class="form-group row">
                      <label class="col-md-5">Nombre Ruta</label>
                      <input
                        type="text"
                        v-model="filtros.nombre"
                        class="form-control form-control-sm col-md-7"
                      />
                    </div>
                    <div class="form-group row">
                      <label class="col-md-5">Código</label>
                      <input
                        type="text"
                        v-model="filtros.codigo"
                        class="form-control form-control-sm col-md-7"
                      />
                    </div>
                    <div class="form-group row">
                      <label class="col-md-5">Origen</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.origen_id"
                        label="nombre"
                        class="form-control form-control-sm p-0 col-md-7"
                        :options="$parent.listasForms.origenes"
                        :filterable="true"
                        @search="$parent.buscarOrigenes"
                        :reduce="(o) => o.id"
                      ></v-select>
                    </div>
                    <div class="form-group row">
                      <label class="col-md-5">Destino</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.destino_id"
                        label="nombre"
                        class="form-control form-control-sm p-0 col-md-7"
                        :options="$parent.listasForms.destinos"
                        :filterable="true"
                        @search="$parent.buscarDestinos"
                        :reduce="(d) => d.id"
                      ></v-select>
                    </div>
                    <div class="form-group row">
                      <label class="col-md-5">Despachado A</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.despachado_a_id"
                        label="descripcion"
                        class="form-control form-control-sm p-0 col-md-7"
                        :options="$parent.listasForms.despachados"
                        :filterable="true"
                        :reduce="(d) => d.numeracion"
                      ></v-select>
                    </div>
                    <div class="form-group row">
                      <label class="col-md-5"> Tipo de Ruta</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.tipo_ruta"
                        label="descripcion"
                        class="form-control form-control-sm p-0 col-md-7"
                        :options="$parent.listasForms.tipoRutas"
                        :filterable="true"
                        :reduce="(tr) => tr.numeracion"
                      ></v-select>
                    </div>
                    <div class="form-group row">
                      <label class="col-md-5"> Horas de Vigencia</label>
                      <input
                        type="number"
                        id="horas_vigencia"
                        v-model="filtros.horas_vigencia"
                        class="form-control form-control-sm col-md-7"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="card card-light">
                  <div class="card-header">
                    <h4 class="card-title">Columnas</h4>
                  </div>
                  <div class="card-body">
                    <div class="row justify-content-beetween">
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="nombre"
                            v-model="form.nombre"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="nombre"
                            >Nombre</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="codigo"
                            v-model="form.codigo"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="codigo"
                            >Código</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="origen_id"
                            v-model="form.origen_id"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="origen_id"
                            >Origen</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="destino_id"
                            v-model="form.destino_id"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="destino_id"
                            >Destino</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="despachado_a_id"
                            v-model="form.despachado_a_id"
                            class="custom-control-input"
                          />
                          <label
                            class="custom-control-label"
                            for="despachado_a_id"
                            >Despachado A</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="tipo_ruta"
                            v-model="form.tipo_ruta"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="tipo_ruta"
                            >Tipo de Ruta</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="horas_vigencia1"
                            v-model="form.horas_vigencia"
                            class="custom-control-input"
                          />
                          <label
                            class="custom-control-label"
                            for="horas_vigencia1"
                            >Horas de Vigencia</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="sitios_y_p_gestion"
                            v-model="form.sitios_y_p_gestion"
                            class="custom-control-input"
                          />
                          <label
                            class="custom-control-label"
                            for="sitios_y_p_gestion"
                            >Sitios y Puntos de Gestión</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-sm bg-olive float-right"
                  @click="generarListadoExcel()"
                  v-if="$store.getters.can('admin.rutas.export')"
                >
                  Generar Listado
                  <i class="fas fa-file-excel"> </i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";

export default {
  name: "RutaExport", //llegada tambien

  components: {
    vSelect,
  },

  data() {
    return {
      form: {
        nombre: true,
        codigo: true,
        origen_id: true,
        destino_id: true,
        despachado_a_id: true,
        tipo_ruta: true,
        horas_vigencia: true,
        sitios_y_p_gestion: true,
      },
      filtros: {
        nombre: null,
        codigo: null,
        origen_id: null,
        destino_id: null,
        despachado_a_id: null,
        tipo_ruta: null,
        horas_vigencia: null,
      },
    };
  },

  methods: {
    generarListadoExcel() {
      this.$parent.cargando = true;
      axios({
        method: "POST",
        url: "/api/admin/rutas/export",
        data: { form: this.form, filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          if (!data.error) {
            this.$swal({
              customClass: {
                container: "my-swal",
              },
              icon: "success",
              title: data.message,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            location.href = data.url;
          } else {
            this.$swal({
              icon: "error",
              title: data.error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
          this.$parent.cargando = false;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = false;
        });
    },
  },
};
</script>
